
import React from 'react';

const GameHero = () => {
  return (
    <div className="relative overflow-hidden">
      <div className="bg-gradient-to-r from-indigo-800 to-purple-700 py-16 md:py-24">
        <div className="container mx-auto px-6 relative z-10">
          <div className="flex flex-col items-center text-center">
            <h1 className="text-4xl md:text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 via-pink-400 to-yellow-300 mb-4 animate-pulse">
              Capybara Clicker 3D
            </h1>
            <p className="text-xl md:text-2xl text-indigo-100 max-w-3xl mb-8">
              Build your capybara empire in this addictive free online incremental game!
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a 
                href="#play-now" 
                className="bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 text-white font-bold py-3 px-8 rounded-full transition-all transform hover:scale-105 hover:shadow-lg"
              >
                Play Now
              </a>
              <a 
                href="#game-guide" 
                className="bg-transparent border-2 border-indigo-300 text-indigo-100 hover:bg-indigo-800 font-bold py-3 px-8 rounded-full transition-all transform hover:scale-105"
              >
                Game Guide
              </a>
            </div>
          </div>
        </div>

        {/* Animated particles effect */}
        <div className="absolute inset-0 overflow-hidden">
          {[...Array(20)].map((_, i) => (
            <div 
              key={i}
              className="absolute rounded-full bg-white opacity-20 animate-pulse"
              style={{
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                width: `${Math.random() * 10 + 5}px`,
                height: `${Math.random() * 10 + 5}px`,
                animationDuration: `${Math.random() * 5 + 2}s`,
                animationDelay: `${Math.random() * 2}s`
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default GameHero;
